<template>
    <b-modal
      size="lg"
      :hideFooter="true"
      id="trainingReportModal"
      @show="onShow"
    >
      <template slot="modal-title">
        <h5>
          <em class="far fa-file-alt"></em> Отчет по занятию в группе
        </h5>
      </template>
      <template slot="default">
        <div class="reportModal">
          <div v-if="rowData ? rowData.length > 0 : false" class="reportTable" ref="gridDiv">
            <report-table :row-data="rowData"></report-table>
          </div>
          <div v-else class="noMistakes">
            <p>
              Ошибок нет
            </p>
          </div>
          <div class="reportModal__mark">
            <div>
              <span class="reportModal__mark__span">Оценка:</span>
              <b-input
                class="reportModal__mark__input"
                v-model="mark"
              >
              </b-input>
            </div>
          </div>
          <div class="reportModal__footer">
            <b-button
              @click="saveChanges"
              class="reportModal__footer__button"
              variant="primary"
            >
              Сохранить изменения
            </b-button>
            <b-button
              @click="closeModal"
              class="reportModal__footer__button"
              variant="outline-primary"
            >
              Отменить изменения
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import ReportTable from '@/components/content/education/training/progress/ReportTable.vue'
import teacherTrainingAPI from '@/api/training/teacher'

export default {
  name: 'ReportModal',
  components: {
    ReportTable
  },
  data() {
    return {
      rowData: [],
      mark: null,
      trainingSessionId: null
    }
  },
  computed: {
    ...mapGetters({
      simulatorMarks: 'educationStudentsManagement/getSimulatorMarks',
      reportId: 'educationStudentsManagement/getReportId',
      testReviewMode: 'educationStudentsManagement/getTestReviewMode',
      test: 'test/getTest'
    })
  },
  methods: {
    ...mapActions({
      pushToasts: 'toasts/pushToasts',
      fetchStudentsProgress: 'educationStudentsManagement/fetchTestStudentsProgress',
      fetchSimulatorMarks: 'educationStudentsManagement/fetchSimulatorMarks'
    }),
    onShow() {
      const simRep = this.simulatorMarks.filter((sm) => sm.id === this.reportId)[0]
      this.rowData = simRep.mistakes
      this.mark = simRep.mark
      this.trainingSessionId = simRep.id
    },
    closeModal() {
      this.$bvModal.hide('trainingReportModal')
    },
    saveChanges() {
      teacherTrainingAPI.changeMark(this.$route.params.trainingId,
        this.trainingSessionId, this.mark).then(() => {
        this.fetchSimulatorMarks({
          simulatorId: this.$route.params.trainingId,
          classes: ['10', '11']
        })
        this.$bvModal.hide('trainingReportModal')
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.reportModal {

  &__correctAnswers {

    margin-bottom: 20px;

    &__button {
      width: 100%;
    }

    &__span {
      font-size: 1.5em;
      color: #0078c1;
      margin-right: 10px;
    }
  }

  &__incorrectAnswers {

    &__button {
      width: 100%;
    }

    &__span {
      font-size: 1.5em;
      color: #373a3d;
      margin-right: 10px;
    }
  }

  &__mark {

    height: 50px;

    font-size: 1.7em;
    margin-top: 10px;

    p {
      width: 70%;
      margin-bottom: 0;
      margin-right: 0;
      float: left;
    }

    &__span {
      margin-left: 40px;
    }

    &__input {
      text-align: center;
      display: inline;
      float: right;
      width: 7%;
    }
  }

  &__footer {
    margin-top: 20px;
    width: 100%;

    &__button {
      width: 48%;
    }

    &__button:first-child {
      margin-right: 4%;
    }
  }
}

@media only screen and (max-width : 991px) {
  .reportModal {

    &__footer {

      margin-top: 40px;

      &__button {
        width: 100%;
      }

      &__button:first-child {
      margin-bottom: 10px;
    }
    }
  }
}

.reportTable {
  height: calc(100vh - 500px);
  border: 1px solid #0078c1;
}

.noMistakes {
  text-align: center;
  padding: 28px 20px;
  color: #0078c1;
  font-size: 2em;
}

</style>
